import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/logo-2.png";
import { IoMdCall, IoMdMail } from "react-icons/io";
import { FaMapMarkerAlt, FaFacebookF,  FaSkype, FaInstagram, FaBars, FaTimes } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaPinterest } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Get the current location
  const navigate = useNavigate();

  return (
    <div className="container mx-auto">
      {/* Main Navbar */}
      <nav className="w-full border-b flex items-center justify-between ">
        {/* Logo Section */}
        <div className="w-[30%] h-auto md:h-44 border-r-2 flex items-center justify-center p-4" onClick={() => navigate("/contact")} >
          <img src={logo} alt="Company Logo" className="w-full h-[80px] md:h-[175px] object-contain"  />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:block w-full">
          <div className="border-b flex justify-between p-1">
          <div className="hidden md:block w-full">
  <div className=" flex justify-between p-1">
    <div className="flex gap-4">
      <a href="mailto:greenarcade.official@gmail.com">
        <IoMdMail className="bg-[#068b07] text-white p-1 cursor-pointer" size={30} />
      </a>
      <a href="https://maps.app.goo.gl/KW6EFRNH3xURjnEc7" target="_blank" rel="noopener noreferrer">
          <FaMapMarkerAlt className="bg-[#068b07] text-white p-1 cursor-pointer" size={30} />
        </a>
    </div>
  </div>
</div>
<div className="flex gap-8 text-gray-500">
  <a href="https://www.facebook.com/greenarcadein/" target="_blank" rel="noopener noreferrer">
    <FaFacebookF size={20} className="hover:text-[#068b07] cursor-pointer" />
  </a>
  <a href="https://www.instagram.com/green_arcade_official/" target="_blank" rel="noopener noreferrer">
    <FaInstagram size={20} className="hover:text-[#068b07] cursor-pointer" />
  </a>
  <a href="https://x.com/greenarcade_off" target="_blank" rel="noopener noreferrer">
    <FaXTwitter size={20} className="hover:text-[#068b07] cursor-pointer" />
  </a>
  <a href="https://in.pinterest.com/greenarcadeofficial/" target="_blank" rel="noopener noreferrer">
    <FaPinterest size={20} className="hover:text-[#068b07] cursor-pointer" />
  </a>
 
</div>

          </div>
          <div className="w-full flex justify-center mt-8 gap-8 font-bold">
            <Link
              to="/"
              className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link ${location.pathname === "/about" ? "active" : ""}`}
            >
              
              About Us
            </Link>
            <Link
              to="/services"
              className={`nav-link ${location.pathname === "/services" ? "active" : ""}`}
            >
              Services
            </Link>
            <Link
              to="/our-works"
              className={`nav-link ${location.pathname === "/our-works" ? "active" : ""}`}
            >
              Our Works
            </Link>
            <Link
              to="/contact"
              className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}>

              Contact Us
            </Link>
          </div>
        </div>

        {/* Contact Section */}
        <div className="hidden md:flex w-[20%] h-44 border-l-2 p-2 flex-col justify-between items-end">
          
  <button className="bg-[#068b07] h-[40%] w-full text-white px-6 py-2 transition-colors"onClick={() => navigate("/contact")}
  >
    GET A QUOTE
  </button>
  <div className="h-[50%] flex items-center gap-2 w-full p-2">
    <a href="tel:+919791692008">
      <IoMdCall className="bg-[#068b07] text-white p-1 cursor-pointer" size={30} />
    </a>
    <div className="flex flex-col pl-2">
      <div className="text-xs font-medium text-gray-600">Call Support 24/7</div>
      <div className="font-semibold text-gray-800">+91 9791692008</div>
    </div>
  </div>
</div>

        {/* Mobile Menu Button */}
        <div className="md:hidden absolute top-4 right-4 p-4 z-50">
          {isOpen ? (
            <FaTimes size={25} className="text-gray-800 cursor-pointer" onClick={() => setIsOpen(false)} />
          ) : (
            <FaBars size={25} className="text-gray-800 cursor-pointer" onClick={() => setIsOpen(true)} />
          )}
        </div>
      </nav>

      {/* Mobile Navigation (Collapsible) */}
    {/* Mobile Navigation (Collapsible) */}
{isOpen && (
  <div className="md:hidden w-full h-full bg-white border-t shadow-md absolute left-0 top-0 z-40">
    <div className="flex flex-col items-center gap-4 py-4 mt-6 font-bold text-gray-700">
      <Link to="/" className={`nav-link ${location.pathname === "/" ? "active" : ""}`} onClick={() => setIsOpen(false)}>
        Home
      </Link>
      <Link to="/about" className={`nav-link ${location.pathname === "/about" ? "active" : ""}`} onClick={() => setIsOpen(false)}>
        About Us
      </Link>
      <Link to="/services" className={`nav-link ${location.pathname === "/services" ? "active" : ""}`} onClick={() => setIsOpen(false)}>
        Services
      </Link>
      <Link to="/our-works" className={`nav-link ${location.pathname === "/our-works" ? "active" : ""}`} onClick={() => setIsOpen(false)}>
        Our Works
      </Link>
      <Link to="/contact" className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`} onClick={() => setIsOpen(false)}>
        Contact Us
      </Link>
    </div>

    <div className="flex flex-col items-center gap-4 p-4 border-t">
      <Link to='/contact'>
      <button className="bg-[#068b07] w-full text-white py-2 transition-colors" onClick={() => setIsOpen(false)}>
        GET A QUOTE
      </button>
      </Link>
    <a href="tel:+919791692008">

      <div className="flex items-center gap-2">
        <IoMdCall className="bg-[#068b07] text-white p-1 rounded" size={30} />
        <div className="text-sm">
          <div className="text-gray-600">Call Support 24/7</div>
          <div className="font-semibold text-gray-800">+91 9791692008</div>
        </div>
      </div>
      </a>
      <div className="flex gap-4 text-gray-500">
        <a href="https://www.facebook.com/greenarcadein/" target="_blank" rel="noopener noreferrer">
          <FaFacebookF size={20} className="hover:text-[#068b07] cursor-pointer" onClick={() => setIsOpen(false)} />
        </a>
        <a href="https://x.com/greenarcade_off" target="_blank" rel="noopener noreferrer">
          <FaXTwitter size={20} className="hover:text-[#068b07] cursor-pointer" onClick={() => setIsOpen(false)} />
        </a>
        <a href="https://www.skype.com/en/" target="_blank" rel="noopener noreferrer">
          <FaSkype size={20} className="hover:text-[#068b07] cursor-pointer" onClick={() => setIsOpen(false)} />
        </a>
        <a href="https://www.instagram.com/green_arcade_official/" target="_blank" rel="noopener noreferrer">
          <FaInstagram size={20} className="hover:text-[#068b07] cursor-pointer" onClick={() => setIsOpen(false)} />
        </a>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default Navbar;
